import { isLoggedIn } from '../../utils/auth'

export default (store) => {
  return ({
    path: 'membership',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      const referral = require('./containers').default
      cb(null, referral)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/MembershipPage/index.js